__turbopack_context__.v({
  "root": "fuQeRq_root",
});
